export const version = "properties/5.0.8";
//# sourceMappingURL=_version.js.map